import { useRef, useState } from 'react';
import toast from 'react-hot-toast';

import Modal from '../../../common/components/modal/modal';
import { useUnblockTask } from '../contexts/tasks';

import '../styles/direct.css';
import '../styles/unblock.css';

export default function UnblockTask({ task }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button type="button" className="detail-head__action" onClick={() => setOpen(true)}>
                Desbloquear
            </button>
            {open && <UnblockTaskModal task={task} onClose={() => setOpen(false)} />}
        </>
    );
}

function UnblockTaskModal({ task, onClose }) {
    const unblock = useUnblockTask(task.id);
    const [reason, setReason] = useState('');
    const [failure, setFailure] = useState('');
    const [mustCheck, setMustCheck] = useState(false);
    const submitting = useRef(false);

    const handleConfirm = async () => {
        const cleaned = reason.trim();
        if (!cleaned || submitting.current || mustCheck) return;
        submitting.current = true;
        setFailure('');
        try {
            await unblock.mutateAsync(cleaned);
            toast.success('Tarea desbloqueada: vuelve a la cola.');
            onClose();
        } catch (err) {
            if (err.isUnconfirmed) {
                setMustCheck(true);
                setFailure('No pudimos confirmar el resultado. Cierra y comprueba el estado antes de volver a intentarlo.');
            } else if (err.status === 409) {
                setMustCheck(true);
                setFailure(err.message || 'La tarea cambió de estado. Cierra y revisa su estado actual.');
            } else {
                setFailure(err.fields?.reason || err.message || 'No se pudo desbloquear la tarea.');
            }
        } finally {
            submitting.current = false;
        }
    };

    return (
        <Modal
            open
            title="Desbloquear tarea"
            busy={unblock.isPending}
            onClose={onClose}
            actions={(
                <>
                    <button type="button" className="direct__button" onClick={onClose} disabled={unblock.isPending}>
                        {mustCheck ? 'Cerrar y comprobar' : 'Cancelar'}
                    </button>
                    <button
                        type="button"
                        className="direct__button direct__button--primary"
                        onClick={handleConfirm}
                        disabled={!reason.trim() || unblock.isPending || mustCheck}
                    >
                        {unblock.isPending ? 'Desbloqueando...' : 'Desbloquear tarea'}
                    </button>
                </>
            )}
        >
            <p className="modal__note">#{task.id} · {task.title}</p>
            <p className="modal__note">
                Volverá a «Lista» con su misma prioridad. Un agente podrá tomarla cuando
                sus dependencias estén resueltas. Sus criterios de aceptación se conservan.
            </p>
            <label className="modal__field">
                <span className="modal__field-label">¿Qué se resolvió? (obligatorio)</span>
                <textarea
                    className="direct__input task-unblock__reason"
                    rows={4}
                    required
                    value={reason}
                    onChange={event => setReason(event.target.value)}
                    disabled={unblock.isPending || mustCheck}
                />
            </label>
            <p className="modal__note">El motivo quedará registrado en el historial.</p>
            {failure && <p className="modal__warn" role="alert">{failure}</p>}
        </Modal>
    );
}
